module.exports = __webpack_public_path__ + "static/media/21ECLAC17.f9f25dc1.jpg";